var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-main"},[_c('BaseLeftPageSubMenu',{attrs:{"menuItems":_vm.filteredPageOptions,"selectedStatus":_vm.selectedSection,"searchEnabled":true},on:{"selectedStatusFilter":_vm.updateActualPage,"searchUpdated":_vm.onMenuSearch}}),_c('div',{staticClass:"content-wrapper"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }